// Este codigo fue generado por Github Copilot Chat
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormArray,
  FormControl,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

import { InputFileType } from './inputFileType';
import { AbstractControlValueAccessorComponent } from '../../helpers/abstract-control-value-accessor';

@Component({
  selector: 'app-input-file',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFileComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFileComponent extends AbstractControlValueAccessorComponent<string> {
  fileName = '';
  errorFile = '';
  @Input() positionIndex = 0;
  @Input() override label = '';
  @Output() fileSelected = new EventEmitter<InputFileType>();
  cdr = inject(ChangeDetectorRef);
  isLoading = false;
  error = false;
  onFileChange(event: Event) {
    this.fileName = '';
    const eventCast = event.target as HTMLInputElement;
    const file: File = eventCast.files![0];

    const control = this.getControl();
    control.setValue(file);
    if (control.status === 'VALID') {
      this.uploadFile(file, control);
    }

    this.cdr.detectChanges();
  }

  uploadFile(file: File, control: FormControl) {
    this.error = false;
    this.fileName = file.name;
    this.isLoading = true;
    control.setValue(null);
    this.cdr.detectChanges();

    // Simular el upload del archivo - pendiente implementación HandleFileUseCase
    const uuid = 'mock-uuid-' + Date.now(); // Mock UUID for now

    this.isLoading = false;
    control.setValue({ uuid, name: this.fileName, contentType: file.type });
    this.cdr.detectChanges();
    this.fileSelected.emit({ name: this.fileName, file, uuid });
  }

  getControl(): FormControl {
    const control =
      this.formControl instanceof FormArray
        ? this.formControl.at(this.positionIndex)
        : this.formControl;
    return control as FormControl;
  }

  cancel() {
    // Limpiar datos del archivo - pendiente implementación HandleFileUseCase para eliminación
    this.formControl.reset();
    this.fileName = '';
    this.cdr.detectChanges();
  }
}
// Este codigo fue generado por Github Copilot Chat
